module.exports = __webpack_public_path__ + "img/trash-2.69637507.svg";